import { useTranslation } from 'next-i18next';
import React from 'react';

import { useFlow } from '../../../../providers';
import { useAnalyticsEmitter } from '../../../../utils/analytics/emitter';
import { PreAuthDrawController } from '../../types';
import { CardButton } from '../shared/CardButton';

interface ShippingAddressButtonProps {
  disabled?: boolean;
  drawController: PreAuthDrawController;
}

export const ShippingAddressButton: React.FC<ShippingAddressButtonProps> = ({
  disabled,
  drawController,
}) => {
  const { goToStep } = useFlow();
  const { addresses } = drawController;
  const { t } = useTranslation(['product', 'countries']);
  const selectedAddress = addresses.find(
    (a) => a.id === drawController.selectedAddress,
  );
  const [emitter] = useAnalyticsEmitter();

  if (!selectedAddress) {
    return (
      <CardButton
        disabled={disabled}
        icon="chevron"
        onClick={() => {
          emitter(
            addresses.length > 0 ? 'edit address' : 'add address',
            'clicked',
          );
          if (addresses.length === 0) {
            goToStep('add_shipping_address');
          } else {
            goToStep('select_shipping');
          }
        }}
      >
        <span className="text-neutral-4">
          {t('product:drawers.review.draw.address.addButton')}
        </span>
      </CardButton>
    );
  }

  return (
    <CardButton
      disabled={disabled}
      icon="edit"
      onClick={() => {
        emitter(
          addresses.length > 0 ? 'edit address' : 'add address',
          'clicked',
        );
        goToStep('select_shipping');
      }}
    >
      <div className="flex flex-col">
        <span>
          {selectedAddress.firstName} {selectedAddress.lastName}
        </span>
        <span className="text-neutral-4">
          {[selectedAddress.addressLine1, selectedAddress.addressLine2]
            .filter(Boolean)
            .join(', ')}
        </span>
        <span className="text-neutral-4">
          {selectedAddress.zip?.toLocaleUpperCase()} {selectedAddress.city},{' '}
          {selectedAddress.countryName}
        </span>
      </div>
    </CardButton>
  );
};
